import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Instasites from 'Assets/images/AppLogo/instasites.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Instasites + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCInstasites(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
